import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function BonusesSection() {
  return <section className="bg-white px-5 py-14 md:py-24" data-id="element-55" data-mp="vtxn4e5y7lz0">
      <Reveal className="mx-auto max-w-3xl" data-id="element-56" data-mp="qtt5ulx7un7q">
        <SectionHeading eyebrow="Included for free" icon={<GiftIcon className="h-7 w-7 text-tr-green md:h-8 md:w-8" strokeWidth={1.75} aria-hidden="true" data-id="element-58" data-mp="14ssuhtkqb23w" />} title="5 Exclusive Bonuses" description="Worth $91 — yours at no extra cost today." data-id="element-57" data-mp="qsrs29otfmmb" />
        <div className="mt-12 space-y-3" data-id="element-59" data-mp="19kkka1w293sz">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-card border border-tr-border bg-white p-4 shadow-card sm:gap-5 sm:p-5" data-id="element-60" data-mp="1nk26qalvw4z6" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-tr-navy text-sm font-bold text-white" data-id="element-61" data-mp="3pqbrl78vgoz0">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="h-[68px] w-[52px] shrink-0 rounded-md border border-tr-border object-cover" data-id="element-62" data-mp="3ttqjav66atsa" />
              <div className="min-w-0 flex-1" data-id="element-63" data-mp="ck1vp2r5thsy">
                <h3 className="text-[15px] font-bold leading-snug text-tr-navy" data-id="element-64" data-mp="cjabsp6xd8ii">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[13px] leading-relaxed text-tr-grey" data-id="element-65" data-mp="gj0zgk15n8it">
                  {bonus.description}{' '}
                  <span className="whitespace-nowrap font-bold text-tr-green" data-id="element-66" data-mp="qax5qidea4y4">
                    {bonus.value}
                  </span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}